import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set page title
    document.title = "Page Not Found - TimeCapsule";
    
    // Add noindex meta tag to prevent search engines from indexing this page
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);
    
    // Clean up function to remove meta tag when component unmounts
    return () => {
      const metaTag = document.querySelector('meta[name="robots"]');
      if (metaTag && metaTag.parentNode) {
        metaTag.parentNode.removeChild(metaTag);
      }
    };
  }, []);

  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        textAlign: 'center',
        padding: '20px',
        color: 'rgba(255,255,255,0.8)',
        fontFamily: 'Arial, sans-serif',
        zIndex: 0
    }}>
        <h1 style={{ 
            fontSize: '2.5rem',
            marginBottom: '1rem',
            background: "linear-gradient(135deg, #7B2CBF, #E31B88)",
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold'
        }}>
            404
        </h1>
        
        <p style={{ 
            maxWidth: '400px', 
            marginBottom: '2rem',
            fontSize: '1.2rem',
            color: 'rgba(255,255,255,0.8)'
        }}>
            Oops! We couldn't find the page you're looking for.
        </p>
        
        <button 
            onClick={() => navigate('/')}
            style={{
                padding: '12px 24px',
                background: "linear-gradient(135deg, #7B2CBF, #E31B88)",
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                transition: 'all 0.2s ease'
            }}
        >
            Return Home
        </button>
    </div>
  );
};

export default NotFoundPage;